import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbTronco extends AppService {

  abstract prefixo: string;
  abstract salvar(tronco: any): Observable<any>;
  abstract getAllTroncos(filter: AppFilter): Observable<any>;
  abstract getAllTroncosDTO(): Observable<any>;
  abstract desativar(id: number);
  abstract getConfigSIP(): any;
}
